export const CAMPUS_INDEX__SET_ALL = 'CAMPUS_INDEX__SET_ALL';
export const CAMPUS_INDEX__ADD_RESOURCE = 'CAMPUS_INDEX__ADD_RESOURCE';
export const CAMPUS_INDEX__UPDATE_RESOURCE = 'CAMPUS_INDEX__UPDATE_RESOURCE';
export const CAMPUS_INDEX__REMOVE_RESOURCE = 'CAMPUS_INDEX__REMOVE_RESOURCE';
export const CAMPUS_INDEX__CLEAR_ALL = 'CAMPUS_INDEX__CLEAR_ALL';
